import { render, staticRenderFns } from "./PersonalCardTypeCards.vue?vue&type=template&id=2869724e&"
import script from "./PersonalCardTypeCards.vue?vue&type=script&lang=js&"
export * from "./PersonalCardTypeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports